
import { useState, useEffect } from 'react';
import { ViewMode } from './types';

export function useSearch() {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const [viewMode, setViewMode] = useState<ViewMode>(() => {
    // Get saved view mode from localStorage or default to "list"
    const savedViewMode = localStorage.getItem("search-view-mode");
    return (savedViewMode as ViewMode) || "list";
  });
  
  // Save viewMode to localStorage when it changes
  useEffect(() => {
    localStorage.setItem("search-view-mode", viewMode);
  }, [viewMode]);
  
  const handleSearch = (query: string) => {
    setSearchQuery(query);
    setSearchModalOpen(true);
  };
  
  return {
    searchQuery,
    searchModalOpen,
    viewMode,
    setSearchModalOpen,
    setViewMode,
    handleSearch
  };
}
